/*--------------------------------------------------------------
# Video Feed
# - carousel (4+ videos): container-bound scroll carousel with paged
#   pagination (one tab per page of cards that fit in view)
# - lightbox: cards open a hidden .video-wrap panel over the page
--------------------------------------------------------------*/

(function () {
	function initCarousel(carousel) {
		var viewport = carousel.querySelector('.video-feed__viewport');
		var track = carousel.querySelector('.video-feed__track');
		// Excludes the trailing __gutter spacer - it's not a card, and counting it
		// would throw off slideStep()'s "distance between two cards" math whenever
		// there's only one real card.
		var slides = track ? Array.prototype.slice.call(track.children).filter(function (el) {
			return !el.classList.contains('video-feed__gutter');
		}) : [];

		if (!viewport || !slides.length) {
			return;
		}

		// Some browsers (Chrome) restore a scrollable element's scroll position
		// across a reload, so without this the carousel can start mid-way through on
		// a refresh instead of at the first card.
		viewport.scrollLeft = 0;

		var prev = carousel.querySelector('.video-feed__arrow--prev');
		var next = carousel.querySelector('.video-feed__arrow--next');
		var tabs = Array.prototype.slice.call(carousel.querySelectorAll('.video-feed__tab'));

		// Distance from one card's start to the next.
		function slideStep() {
			if (slides.length < 2) {
				return slides[0].offsetWidth;
			}
			return slides[1].offsetLeft - slides[0].offsetLeft;
		}

		// How many whole cards fit in view - one page, and what one arrow press
		// moves. Mobile cards fill the viewport, so this is 1 there.
		function viewCount() {
			var step = slideStep();
			return step > 0 ? Math.max(1, Math.floor(viewport.clientWidth / step)) : 1;
		}

		function pageWidth() {
			return slideStep() * viewCount();
		}

		// The markup carries one tab per card - the most that can be needed. Any
		// beyond the current page count get hidden rather than removed, so they come
		// back if the viewport widens or narrows again.
		function pageCount() {
			return Math.max(1, Math.min(tabs.length, Math.ceil(slides.length / viewCount())));
		}

		function maxScroll() {
			return viewport.scrollWidth - viewport.clientWidth;
		}

		function updateControls() {
			var left = viewport.scrollLeft;
			var max = maxScroll();

			if (prev) {
				prev.disabled = left <= 1;
			}
			if (next) {
				next.disabled = left >= max - 1;
			}

			if (tabs.length) {
				var pages = pageCount();
				var page = pageWidth() > 0 ? Math.round(left / pageWidth()) : 0;
				// Snap the last tab active once we reach the end.
				if (left >= max - 1) {
					page = pages - 1;
				}
				page = Math.max(0, Math.min(pages - 1, page));
				tabs.forEach(function (tab, index) {
					var active = index === page;
					tab.hidden = index >= pages;
					tab.classList.toggle('is-active', active);
					tab.setAttribute('aria-selected', active ? 'true' : 'false');
				});
			}
		}

		function scrollByCards(count) {
			viewport.scrollTo({
				left: viewport.scrollLeft + count * slideStep(),
				behavior: 'smooth'
			});
		}

		if (prev) {
			prev.addEventListener('click', function () {
				scrollByCards(-viewCount());
			});
		}
		if (next) {
			next.addEventListener('click', function () {
				scrollByCards(viewCount());
			});
		}

		tabs.forEach(function (tab, index) {
			tab.addEventListener('click', function () {
				viewport.scrollTo({
					left: Math.min(maxScroll(), index * pageWidth()),
					behavior: 'smooth'
				});
			});
		});

		var scrollTimer;
		viewport.addEventListener('scroll', function () {
			window.clearTimeout(scrollTimer);
			scrollTimer = window.setTimeout(updateControls, 60);
		});

		window.addEventListener('resize', updateControls);

		updateControls();
	}

	function initLightbox(root) {
		var lightbox = root.querySelector('[data-video-feed-lightbox]');

		if (!lightbox) {
			return;
		}

		// In carousel mode the section clips its own overflow so the bleeding card
		// row can't scroll the page sideways - which would clip a fixed overlay
		// inside it too. Moving the lightbox to the body puts it out of reach of
		// that, and of any other stacking context an ancestor might create.
		document.body.appendChild(lightbox);

		var panels = Array.prototype.slice.call(lightbox.querySelectorAll('[data-video-panel]'));
		var closeButton = lightbox.querySelector('.video-feed__lightbox-close');
		var lastTrigger = null;

		// The players are built by the theme's own scripts (youtube.js for YouTube,
		// the video component for Vimeo), which keep their player instances to
		// themselves - so stopping playback goes through each iframe's postMessage
		// API instead. Sending both dialects is harmless: each player ignores the
		// message it doesn't recognise.
		function stopPanel(panel) {
			var wrap = panel.querySelector('.video-wrap');
			var iframe = panel.querySelector('iframe');

			if (iframe && iframe.contentWindow) {
				iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
				iframe.contentWindow.postMessage('{"method":"pause"}', '*');
			}

			// Bring the poster and play button back for the next time it's opened.
			if (wrap) {
				wrap.classList.remove('interacted');
			}
			var vimeoButton = panel.querySelector('.vimeo-button');
			if (vimeoButton) {
				vimeoButton.style.display = '';
			}
		}

		function close() {
			panels.forEach(function (panel) {
				stopPanel(panel);
				panel.hidden = true;
			});
			lightbox.hidden = true;
			document.body.style.overflow = '';

			if (lastTrigger) {
				lastTrigger.focus();
				lastTrigger = null;
			}
		}

		function open(index, trigger) {
			panels.forEach(function (panel) {
				panel.hidden = panel.getAttribute('data-video-panel') !== String(index);
			});
			lightbox.hidden = false;
			document.body.style.overflow = 'hidden';
			lastTrigger = trigger;

			if (closeButton) {
				closeButton.focus();
			}
		}

		Array.prototype.slice.call(root.querySelectorAll('[data-video-open]')).forEach(function (card) {
			card.addEventListener('click', function () {
				open(card.getAttribute('data-video-open'), card);
			});
		});

		// Both the X and the blurred background close the overlay.
		Array.prototype.slice.call(lightbox.querySelectorAll('[data-video-close]')).forEach(function (el) {
			el.addEventListener('click', close);
		});

		document.addEventListener('keydown', function (event) {
			if ('Escape' === event.key && !lightbox.hidden) {
				close();
			}
		});
	}

	function init() {
		Array.prototype.slice.call(document.querySelectorAll('[data-video-feed]')).forEach(function (root) {
			Array.prototype.slice.call(root.querySelectorAll('[data-video-feed-carousel]')).forEach(initCarousel);
			initLightbox(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
